import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { useFormatCdnRoute } from '@hooks';
import { ReactFCV } from '@types';

import { StyledImage } from './styled';

interface IImageProps extends IBasicStyledProps {
  url: string;
  alt?: string;
}

export const Image: ReactFCV<IImageProps> = ({ url, alt, ...rest }) => {
  const formatCdnAddress = useFormatCdnRoute();

  return <StyledImage src={formatCdnAddress(url)} alt={alt} {...rest} />;
};
